/**
 * Inject the needed env variables through `$env` property of context in Vue components and pages
 */
export default (_, inject) => {
  inject('env', {
    backofficeUrl: process.env.NUXT_ENV_BACKOFFICE_URL,
    supportUrl: process.env.NUXT_ENV_SUPPORT_URL || 'https://ticket.seesaw.it'
  })
}